import { styled } from "goober";
import { ButtonPress } from "../Button/ButtonPress";

export const DisclosureToggle = styled(ButtonPress)`
  & > span {
    transition: transform var(--motion-base) var(--ease-out);
  }
  &[aria-expanded="true"] > span {
    transform: rotate(180deg);
  }
`;
